module.exports = __webpack_public_path__ + "img/introduce2.78e9800f.jpg";